// ── API endpoint constants ─────────────────────────────────────────

const GITHUB_RAW_BASE = "https://raw.githubusercontent.com/rosterOS/rosterOS-data/main";

export const API_ADP_URL = `${GITHUB_RAW_BASE}/adp.json`;
export const API_SCHEDULE_URL = `${GITHUB_RAW_BASE}/schedule.json`;
export const DEFAULT_RANKINGS_URL = `${GITHUB_RAW_BASE}/default-rankings.json`;

export const SNAPSHOT_INDEX_URL = "/snapshot-index.json";
export const ADP_HISTORY_URL = "/adp-history.json";
export const LAST_UPDATED_URL = "/last-updated.json";

// Current DraftKings best-ball ADP — a public, CORS-open aggregator (Occupy
// Fantasy). `curr_adp` is field-wide and current; fetched directly in the
// browser. See AdpContext. If it's ever unreachable we fall back to the bundled
// asset below.
export const DK_ADP_LIVE_URL = "https://www.occupyfantasyapi.com/best_ball/adps?site=draftkings&contest=all";

// DraftKings ADP fallback bundle (built by scripts/build-dk-adp.cjs). Only the
// floor if DK_ADP_LIVE_URL is unreachable; otherwise the live feed wins.
export const DK_ADP_URL = "/adp-draftkings.json";

export const FETCH_TIMEOUT_MS = 10_000;
